module.exports = __webpack_public_path__ + "img/fbf3-6b.prt.71562d96.jpg";